import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { RoutesEnum } from "../model/enum/RoutesEnum";

export const SmallFooter = () => {
  const { t } = useTranslation();
  return (
    <div className="px-10 max-w-[1440px] mx-auto">
      <div className="w-full bg-gradient-to-r from-brand-gradientDarkBlue to-brand-gradientLightBlue rounded-3xl flex flex-col relative overflow-hidden mb-10">
        <div className="w-full py-10 px-10 sm:px-16 flex flex-col-reverse sm:flex-row sm:items-center justify-between gap-6 z-10">
          <p className="text-white/50 text-base hidden md:block">
            &copy; {new Date().getFullYear()} Aplik s.r.o. | {t("copyright")}
          </p>
          <div className="flex flex-col gap-2 md:hidden">
            <p className="text-white/50 text-base">
              &copy; {new Date().getFullYear()} Aplik s.r.o.
            </p>
            <p className="text-white/50 text-base">{t("copyright")}</p>
          </div>
          <div className="flex flex-col sm:flex-row text-white/50 text-base gap-y-2 gap-x-10">
            <Link to={RoutesEnum.EU_PROJECTS}>{t("euProjects")}</Link>
            {/* <Link to={RoutesEnum.GDPR}>GDPR</Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};
